module.exports = __webpack_public_path__ + "872e122df92fbe0e167a9deb4051207e.svg";